import { Injectable } from "@angular/core";
import Swal from "sweetalert2";
  
declare var $: any;

@Injectable()
export class PluginAssinaturaService {
  private requiredVersionPlugin: string = "4.0.0";
  private connection: any;
  private proxy: any;

  constructor() {
    this.initializeSignalRConnection();
  }

  private initializeSignalRConnection(): void {
    this.connection = $.hubConnection("http://localhost:9523/signalr");
    this.proxy = this.connection.createHubProxy("hubService");
  }

  private async testSign_Plugin() {
    return new Promise<void>((resolve) => {
      let timeout = null;

      this.resetSwal(true);

   

      Swal.fire({
        title: "Verificando plugin de assinatura.",
        currentProgressStep: "1",
      /*    didOpen: function () {
          Swal.showLoading();
        }   */
      });

      this.initializeSignalRConnection();

      timeout = setTimeout(() => {
        this.connection.stop();
        this.modalInstalacaoPlugin().then(() => {
          return resolve();
        });
      }, 120000); // 2 Mintutos de Time Out

      this.proxy.on("response", (data) => {

        clearTimeout(timeout);
        this.connection.stop();
        if (data && data.State === 0 && data.Version === this.requiredVersionPlugin) resolve();
        else {
          this.modalInstalacaoPlugin().then(() => {
            return resolve();
          });
        }
      });

      this.connection
        .start()
        .then(() => {
          this.proxy.invoke("Sign", { action: "check-sign-plugin" });
        })
        .catch((error: any) => {
          clearTimeout(timeout);
          this.modalInstalacaoPlugin().then(() => {
            return resolve();
          });
          console.log("Erro na conexão: " + error);
        });
    });
  }

  signDocuments(base64List, thumbprint) {
    this.resetSwal(true);
    let timeout = null;

    if (base64List) {
      const requisicao = {
        Action: "sign-document-plugin",
        Thumbprint: thumbprint,
        Pattern: "CADES",
        Algorithm: "SHA1",
        isRSA: false,
        Hash: base64List,
      };

      return new Promise<any>((resolve, reject) => {
        return this.testSign_Plugin().then(() => {
          this.resetSwal(true);
          Swal.fire({
            title: "Assinando documentos.",
            allowOutsideClick: false,
            allowEscapeKey: false,
         /*    : function () {
              Swal.showLoading();
            }, */
          });

          this.initializeSignalRConnection();

          timeout = setTimeout(() => {
            this.connection.stop();
            this.modalErroAssinatura({Error: 'O plugin de assinatura não respondeu'}); 
          }, 120000); // 2 Mintutos de Time Out

          this.proxy.on("response", (data) => {
            clearTimeout(timeout);
            this.connection.stop();
            Swal.close();
            if (data && data.State === 2) resolve(data);
            else {
              this.modalErroAssinatura(data); 
            }
          });

          this.connection
            .start()
            .then(() => {
              this.proxy
                .invoke("Sign", requisicao)
            })
            .catch((error: any) => {
              clearTimeout(timeout);
              this.modalErroAssinatura(error);
              console.log("Erro na conexão: " + error);
            });
        });
      });
    }
  }

  private modalInstalacaoPlugin() {
    return new Promise<void>((resolve, reject) => {
      window.open(
        "https://www.safeweb.com.br/ecommerce/downloads/Assinador.Setup.exe",
        "_blank"
      );

      this.resetSwal();
      Swal.fire({
        title: "2º Passo",
        text: "Deve-se instalar o plugin de assinatura.",
        imageUrl: "https://safeweb.com.br/ecommerce/images/chromeInstall.jpg",
        currentProgressStep: "2",
        confirmButtonText: "Já instalei",
      }).then(() => {
        this.testSign_Plugin().then(() => {
          return resolve();
        });
      });
    });
  }

  private modalErroAssinatura(response: any) {
    if (
      (response &&
        response.Error.toString().includes(
          "O conjunto de chaves não existe"
        )) ||
      response.Error.toString().includes(
        "Não foi possível buscar o certificado"
      )
    ) {
      Swal.fire({
        title: "Erro ao assinar o documento.",
        text: "Verifique se o certificado está conectado e tente novamente.",
       });
    } else {
      Swal.fire({
        title: "Erro ao assinar o documento.",
        text: response.Error,
       });
    }
  }

  private resetSwal(resetSteps: boolean = false) {
    if (resetSteps) {
      Swal.mixin({
        progressSteps: [],
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } else {
      Swal.mixin({
        progressSteps: ["1", "2"],
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    }
  }
}
